<template>
    <section class="dependent-view">
        <HeaderComponent :subTitle="getCurrDependent.CDIDCONSUMID || ''" :title="getCurrDependent.NMCONSUMIDOR || 'Filho'"/>
        <div class="dependent-container">
            <DependentListComponent :carrouselItens="dependentOptions.filter((item) => (!item.checkVisibility || (item.checkVisibility && !isFinancialResponsible)) && item.isVisible)" @componentEvent="handleEvent"/>
        </div>

        <ModalInfo @actionTrue="cardAction" @actionFalse="closeModalInfo" />
    </section>
</template>

<script>
import HeaderComponent from '@/components/header/HeaderComponent.vue'
import DependentListComponent from '@/components/menus/DependentListComponent.vue'
import ModalInfo from '@/components/modals/ModalInfo.vue'
import { hasAnySubscriptionService } from '@/components/controllers/SubscriptionServicesController'
import { getCardStatus, toggleCardStatus } from '@/components/controllers/CardsController'
import { showSuccessNotification } from '@/libs/Util.js'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'DependentView',
    components: {
        HeaderComponent,
        DependentListComponent,
        ModalInfo
    },
    data () {
        return {
            cardData: []
        }
    },
    computed: {
        ...mapGetters(['getCurrDependent', 'dependentOptions', 'isFinancialResponsible'])
    },
    created () {
        hasAnySubscriptionService()
    },
    methods: {
        handleEvent: async function (cItem) {
            if (cItem.cardStatus) {
                const cardData = await getCardStatus()
                if (cardData[0]) {
                    this.cardData = cardData[0]
                    const cardStatus = cardData[0].IDSITCONSUMI === '1' ? 'desbloqueado' : 'bloqueado'
                    const cardAction = cardData[0].IDSITCONSUMI === '1' ? 'bloqueá-lo' : 'desbloqueá-lo'
                    this.showModalInfo({
                        type: cItem.type,
                        text: `O cartão encontra-se ${cardStatus}. Deseja ${cardAction}?`,
                        icon: cItem.icon,
                        open: true
                    })
                } else {
                    this.showModalInfo({
                        type: 'default',
                        text: 'Não foi possível obter o status do cartão. Tente novamente mais tarde.',
                        icon: 'fa-solid fa-xmark',
                        open: true
                    })
                }
            } else {
                this.$router.push('/dependent' + cItem.action)
            }
        },
        cardAction: function () {
            toggleCardStatus(this.cardData.IDSITCONSUMI).then((res) => {
                if (res && res.rowsAffected) {
                    this.toggleCardStatusDep(this.cardData.IDSITCONSUMI)
                    showSuccessNotification({
                        title: '',
                        text: 'Cartão atualizado com sucesso.'
                    })

                    if (this.cardData.IDSITCONSUMI === '1') {
                        // mudou para '2' e deve ir para a home
                        this.$router.push('/home')
                    }
                }
            })
        },
        ...mapActions(['showModalInfo', 'closeModalInfo', 'toggleCardStatusDep'])
    }
}
</script>

<style lang="less" scoped>
// if the screen is too small, the header will have a margin bottom
.dependent-container {
    position: relative;
    margin-bottom: 50px;
}

</style>
